/**
 * Add endpoints of specific api calls in this file
 * 
 * for example : 
 *      {endpoint: "api/public/do_something", method: "POST", args: ["param1", "param2"] },
 * 
 * will be available in controllers as :
 *      this.api.public.do_something(param1, param2, function(err){...})
 */

module.exports = [
    {endpoint: "api/extrabat/getAuthUrl", method: "GET", args: ["resellerCode"]},
    {endpoint: "api/extrabat/searchCustomer", method: "GET", args: ["resellerCode", "customerSearch"]},
    {endpoint: "api/public/getLang", method: "GET", args: ["token"]},
    {endpoint: "api/public/getOptin", method: "GET", args: ["c_id"]},
    {endpoint: "api/public/updateOptin", method: "GET", args: ["c_id", "c_optin_newsletter", "c_optin_bayrol", "c_optin_dealer"]},
    {endpoint: "api/stats/diagsByDayOfWeek", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/diagsByMonth", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/diagsByType", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/diagsByBasin", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/diagsByDisinfectant", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/diagsByVolume", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/diagsByChlorine", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/diagsByBromine", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/diagsByChlorineSpa", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/diagsByBromineSpa", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/diagsByRates", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/diagsByRatesSpa", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/customersByBasin", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/customersByFilter", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/customersByVolume", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/customersByDisinfectant", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/customersByMonth", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/stats/callToActionConvertion", method: "POST", args: ["search", "lang"]},
    {endpoint: "api/xls/exportXls", method: "POST", sendMethod: "post", dataEncoding: "multipart", args: [
        "data"
    ] },
    {endpoint: "api/ping/pong", method: "GET"},
    {endpoint: "api/pdf/gen", method: "POST", sendMethod: "post", dataEncoding: "multipart", args: [
        "filename", 
        "html", 
        "lang",
        {name: "noFooter", optional: true}
    ] },
    {endpoint: "api/pdf/gen2", method: "POST", dataEncoding: "multipart", responseEncoding: "blob", args: [
        "filename", 
        "html", 
        "lang",
        {name: "noFooter", optional: true}
    ] },
] ;